import bodyCountMapping from "./functions/bodyCountMapping";
import getPrice, { addJumpOffHandler, addTooltipHandler, clearResult, generateProductPage, getFinePrint, getProductTooltip, showError } from "./functions/getPrice";
// import { lifterror, showerror } from "./functions/showError";
import * as autocomplete from "./functions/autocomplete";
import * as validation from "./functions/validation";
import selector from "./functions/selector";
import * as bodySwap from "./functions/bodySwap";
import { log } from "./functions/logger";
document.addEventListener("DOMContentLoaded", () => {
    //initial Values
    window.ccitycode = 0;
    //@ts-ignore
    window.ccitycodes = {
        "privat": 0,
        "gewerbe": 0,
        "waermepumpe": 0,
        "mieterstrom": 0
    };
    //@ts-ignore
    window.mode = "privat";
    window.ddistrictcode = 0;
    window.business = false;
    window.waermepumpe = false;
    window.mieterstrom = false;
    window.error = false;
    window.maxbody = 4;
    window.bodycount = 2;
    //@ts-ignore
    window.selectedPlzEntry = "";
    //@ts-ignore
    window.errors = [];
    clearResult();
    //initialize dropper state
    jQuery(selector.IncrementInputs).each((i, el) => {
        jQuery(el).children("svg").each((i, el) => {
            let e = jQuery(el);
            bodySwap.TriggerBodyUpdate(e);
        });
    });
    jQuery(selector.KWH).each((index, e) => {
        jQuery(e).on("paste", () => {
            return false;
        });
    });
    jQuery(selector.STREET).on("select", async () => {
        validation.validateStreet();
    });
    jQuery(selector.PLZ).on("select", async () => {
        if (validation.validatePlzCity()) {
            await autocomplete.loadAutocomplete(selector.AUTOCOMPLETE_STREET, `https://adressprovider.bsw.trojahn-horse.de/street/${window.ccitycode}`);
        }
    });
    jQuery(selector.PLZ).on("change", async () => {
        //@ts-ignore
        window.ccitycodes[window.mode] = 0;
        window.ccitycode = 0;
        validation.validatePlzCity();
    });
    jQuery(selector.PLZ).on("input", (event) => {
        if (/^[0-9]+$/.test(event.target.value) == false) {
            event.target.value = event.target.value.slice(0, -1);
        }
    });
    jQuery(selector.PLZ).on("keyup", async function (event) {
        let value = String(jQuery(event.target).val()).replace(".", "").replace(",", "");
        jQuery(event.target).val(value);
        if (value.length >= 4 && /^\d+$/.test(value)) {
            await autocomplete.loadAutocomplete(event.target, `https://adressprovider.bsw.trojahn-horse.de/postcode/${jQuery(event.target).val()}`);
        }
        await autocomplete.UpdateAutocompleteOptions(event);
    });
    jQuery(selector.TAB).each((i, element) => {
        let id = jQuery(element).attr("id");
        // if (id?.includes("waermepumpe")) {
        //   jQuery(element).css("display", "none");
        // }
        if (id?.includes("gewerbe") && window.business != true) {
            jQuery(element).on("click", (event) => {
                //@ts-ignore
                if (window.mode != "gewerbe") {
                    //@ts-ignore
                    window.ccitycode = window.ccitycodes.gewerbe;
                }
                window.business = true;
                window.waermepumpe = false;
                window.mieterstrom = false;
                jQuery(selector.KWH).val(String(bodyCountMapping(window.bodycount)));
                jQuery(selector.TarifrechnerResult).slideUp();
                jQuery(selector.TarifrechnerFinePrint).slideUp();
                //@ts-ignore
                window.mode = "gewerbe";
                bodySwap.updateBodys();
                validation.validateUsage();
                validation.validateTariffcalculator();
            });
        }
        else if (id?.includes("waermepumpe") && window.waermepumpe != true) {
            jQuery(element).on("click", (event) => {
                //@ts-ignore
                if (window.mode != "waermepumpe") {
                    //@ts-ignore
                    window.ccitycode = window.ccitycodes.waermepumpe;
                }
                window.business = false;
                window.waermepumpe = true;
                window.mieterstrom = false;
                jQuery(selector.KWH).val(String(bodyCountMapping(window.bodycount)));
                jQuery(selector.TarifrechnerResult).slideUp();
                jQuery(selector.TarifrechnerFinePrint).slideUp();
                //@ts-ignore
                window.mode = "waermepumpe";
                bodySwap.updateBodys();
                validation.validateUsage();
                validation.validateTariffcalculator();
            });
        }
        else if (id?.includes("mieterstrom") && window.mieterstrom != true) {
            jQuery(element).on("click", (event) => {
                //@ts-ignore
                if (window.mode != "mieterstrom") {
                    //@ts-ignore
                    window.ccitycode = window.ccitycodes.mieterstrom;
                }
                window.business = false;
                window.waermepumpe = false;
                window.mieterstrom = true;
                jQuery(selector.KWH).val(String(bodyCountMapping(window.bodycount)));
                jQuery(selector.TarifrechnerResult).slideUp();
                jQuery(selector.TarifrechnerFinePrint).slideUp();
                //@ts-ignore
                window.mode = "mieterstrom";
                bodySwap.updateBodys();
                validation.validateUsage();
                validation.validateTariffcalculator();
            });
        }
        else if (id?.includes("privat")) {
            jQuery(element).on("click", (event) => {
                //@ts-ignore
                if (window.mode != "privat") {
                    //@ts-ignore
                    window.ccitycode = window.ccitycodes.privat;
                }
                window.business = false;
                window.waermepumpe = false;
                window.mieterstrom = false;
                jQuery(selector.KWH).val(String(bodyCountMapping(window.bodycount)));
                jQuery(selector.TarifrechnerResult).slideUp();
                jQuery(selector.TarifrechnerFinePrint).slideUp();
                //@ts-ignore
                window.mode = "privat";
                bodySwap.updateBodys();
                validation.validateUsage();
                validation.validateTariffcalculator();
            });
        }
        validation.validateUsage();
        validation.validateTariffcalculator();
        // jQuery(selector.KWH).each((i, el) => {
        //   if (jQuery(el).is(":visible") && Number.parseInt(String(jQuery(el).val())) > 20000) {
        //     jQuery(".tarifrechner-input fomr button[type=submit]").prop("disabled", true);
        //   } else {
        //     jQuery(".tarifrechner-input fomr button[type=submit]").prop("disabled", false);
        //   }
        // })
    });
    var div = jQuery("div[autocomplete-for=mieterstrom_tarif_strasse]");
    div.attr("class", "autocomplete-list absolute w-full bg-white top-12 shadow-center z-0");
    jQuery(selector.STREET).on("keyup", async function (event) {
        var div = jQuery("div[autocomplete-for=" + jQuery(event.target).attr("id") + "]");
        if (window.ccitycode !== 0 && div.children("div:not(.default)").length == 0 && String(jQuery(event.target).val()).length == 3) {
            await autocomplete.loadAutocomplete(event.target, `https://adressprovider.bsw.trojahn-horse.de/street/${window.ccitycode}`);
        }
        else {
            await autocomplete.UpdateAutocompleteOptions(event);
        }
    });
    jQuery(selector.STREET).on("blur", (event) => {
        validation.validateStreet();
    });
    jQuery(selector.NUMBER).on("blur", (event) => {
        //@ts-ignore
        event.target.value = event.target.value.replaceAll(" ", "").trim();
        validation.validateHousenumber();
    });
    jQuery(selector.PLZ).on("blur", (event) => {
        validation.validatePlzCity();
    });
    jQuery(selector.KWH).on("blur", (event) => {
        validation.validateUsage();
    });
    //we are done?
    jQuery(selector.NUMBER).each((i, el) => {
        jQuery(el).on("keyup", (event) => {
            if (validation.validateHousenumber()) {
                clearResult();
            }
        });
        // jQuery(el).on("keyup", (event) => {
        //   validation.checkHouseNumber((event.target as HTMLInputElement).value.trim())
        //     ? getPrice()
        //     : jQuery(selector.TarifrechnerResult).slideUp(), jQuery(selector.TarifrechnerFinePrint).slideUp();
        // });
    });
    jQuery(selector.KWH).each((i, el) => {
        jQuery(el).val(bodyCountMapping(window.bodycount));
        //@ts-ignore
        if (window.mode == "privat") {
            validation.validateUsage();
        }
    });
    jQuery(selector.PLZ).each((i, el) => {
        el.parentElement?.setAttribute("data-status", "");
    });
    // bruder muss groß
    jQuery(selector.KWH).each((i, el) => {
        jQuery(el).on("input", (event) => {
            if (/^[0-9]+$/.test(event.target.value) == false) {
                el.value = event.target.value.slice(0, -1);
            }
        });
        jQuery(el).on("keyup", async (event) => {
            // jQuery(selector.KWH).each((j, el) => {
            //   (el as HTMLInputElement).value = (event.target as HTMLInputElement).value
            // })
            validation.validateUsage();
            return;
        });
    });
    jQuery(selector.TARIFFCALCULATORFORM).on("submit", async (event) => {
        if (!validation.validateTariffcalculator())
            return;
        event.preventDefault();
        let button = jQuery(selector.TARIFFCALCULATORBUTTON);
        button.addClass("spinner");
        clearResult();
        window.products = [];
        try {
            await getPrice();
            await setTimeout(() => { }, 500);
        }
        catch (ex) {
            return;
        }
        if (window.products.length > 0) {
            //@ts-ignore
            let document = "";
            // let strompreisbremse = window.business == true || window.products.length >= 2;
            let strompreisbremse = false;
            let foundMieterstrom = false;
            for (let i = 0; i < window.products.length; i++) {
                try {
                    log(window.products[i]);
                    document = await generateProductPage(window.products[i], (strompreisbremse).toString());
                    log(document);
                    jQuery(selector.TarifrechnerResult).append(jQuery.parseHTML(document));
                    document = await getProductTooltip(window.products[i], (strompreisbremse).toString());
                    jQuery(selector.TarifrechnerResult).append(jQuery.parseHTML(document));
                    if (strompreisbremse) {
                        addTooltipHandler(window.products[i]);
                    }
                    if (window.products[i].Info.toLowerCase().includes("sonne") || window.products[i].Info.toLowerCase().includes("wärme")) {
                        foundMieterstrom = true;
                    }
                    addJumpOffHandler(window.products[i]);
                }
                catch (ex) {
                    console.error(ex);
                    await showError(selector.ERRORS.OEKOSTROM);
                    break;
                }
            }
            jQuery(selector.Tarifgruppe).append(await getFinePrint(strompreisbremse));
            if (!foundMieterstrom && (window.mieterstrom || window.waermepumpe)) {
                await showError(selector.ERRORS.MIETERSTROM);
            }
        }
        else {
            await showError(selector.ERRORS.OEKOSTROM);
        }
        jQuery(selector.TarifrechnerResult).slideDown();
        button.removeClass("spinner");
    });
}); //end domcontentloaded
